module.exports = __webpack_public_path__ + "static/media/coming-soon.e13f48dd.png";